import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["onChange"];
import React, { memo, useState, useCallback, useEffect } from 'react';
import { createUseStyles, Select } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'SelectCell');
const SelectCell = /*#__PURE__*/memo(params => {
  var _params$value;
  const {
    t
  } = useWeb5Context();
  const [value, setValue] = useState((_params$value = params.value) !== null && _params$value !== void 0 && _params$value.value ? params.value || '' : undefined);
  const [error, setError] = useState('');
  const classes = useStyles();
  const field = params.colDef.field;
  const _params$inputParams = params.inputParams,
    {
      onChange
    } = _params$inputParams,
    inputParams = _objectWithoutProperties(_params$inputParams, _excluded);
  const handleOnChange = useCallback(newValue => {
    const id = params.data.id || params.data.Id || params.data.ID || '';
    onChange({
      rowIndex: params.node.rowIndex,
      id,
      field,
      value: newValue
    });
    setValue(newValue);
  }, [onChange, field, params]);
  useEffect(() => {
    var _inputParams$errors, _inputParams$errors$r, _inputParams$errors$r2;
    const rowIndex = params.node.rowIndex;
    if (!(inputParams !== null && inputParams !== void 0 && (_inputParams$errors = inputParams.errors) !== null && _inputParams$errors !== void 0 && (_inputParams$errors$r = _inputParams$errors.rows) !== null && _inputParams$errors$r !== void 0 && (_inputParams$errors$r2 = _inputParams$errors$r[rowIndex]) !== null && _inputParams$errors$r2 !== void 0 && _inputParams$errors$r2.error)) {
      setError('');
    } else {
      var _inputParams$errors2, _inputParams$errors2$, _inputParams$errors2$2;
      const errorText = inputParams === null || inputParams === void 0 ? void 0 : (_inputParams$errors2 = inputParams.errors) === null || _inputParams$errors2 === void 0 ? void 0 : (_inputParams$errors2$ = _inputParams$errors2.rows) === null || _inputParams$errors2$ === void 0 ? void 0 : (_inputParams$errors2$2 = _inputParams$errors2$[rowIndex]) === null || _inputParams$errors2$2 === void 0 ? void 0 : _inputParams$errors2$2.error;
      setError(errorText);
    }
  }, [inputParams.errors, params]);
  if (!params.inputParams) return null;
  const placeholder = inputParams.isReadOnly ? t('label_advanced_filter_option_empty') : t('label_selectone');
  return /*#__PURE__*/React.createElement("div", {
    className: ['w5-cell', classes.editableCell].join(' ')
  }, /*#__PURE__*/React.createElement(Select, _extends({
    value: value,
    onChange: handleOnChange
  }, inputParams, {
    placeholder: placeholder,
    error: error,
    isFullWidth: true
  })));
});
export default SelectCell;